export const DELETION_REQUEST_TEXT = 'Deletion request has been sent';
export const DELETE_SUCCESSFULLY_TEXT = 'Delete Successfully';
export const DELETE_FAIL_TEXT = 'Delete Fail. Please try again!';
export const TYPE_FINANCIAL = 'Financial';
export const TYPE_STRATEGIC = 'Strategic';
